import { FilterWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Filter')
export class FilterNodeSchemaProvider extends SchemaProvider<FilterWorkflowNode> {}
